export * from './link-button.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/link-button/index.ts